import React from 'react';
import {withStyles} from 'material-ui/styles';
import {Icon, IconButton, MuiThemeProvider, Tooltip, Typography, Card} from 'material-ui';
import Toolbar from 'react-big-calendar/lib/Toolbar';
import {navigate} from 'react-big-calendar/lib/utils/constants';
import classNames from 'classnames';
import {FuseThemes} from '@fuse';
import moment from 'moment';
import {connect} from 'react-redux';
import axios from 'axios';

const headerHeight = 200;

const styles = theme => ({
    root: {
        height            : headerHeight,
        minHeight         : headerHeight,
        display           : 'flex',
        backgroundImage   : 'url("../../assets/images/backgrounds/header-bg.png")',
        backgroundColor   : '#FAFAFA',
        color             : '#FFFFFF',
        backgroundSize    : 'cover',
        backgroundPosition: '0 50%',
        backgroundRepeat  : 'no-repeat',
        position          : 'relative',
        '&:before'        : {
            content   : "''",
            position  : 'absolute',
            top       : 0,
            right     : 0,
            bottom    : 0,
            left      : 0,
            zIndex    : 1,
            background: 'rgba(0, 0, 0, 0.45)'
        },
        '&.Jan'           : {
            backgroundImage   : "url('/assets/images/backgrounds/winter.jpg')",
            backgroundPosition: '0 85%'
        },
        '&.Feb'           : {
            backgroundImage   : "url('/assets/images/backgrounds/winter.jpg')",
            backgroundPosition: '0 85%'
        },
        '&.Mar'           : {
            backgroundImage   : "url('/assets/images/backgrounds/spring.jpg')",
            backgroundPosition: '0 40%'
        },
        '&.Apr'           : {
            backgroundImage   : "url('/assets/images/backgrounds/spring.jpg')",
            backgroundPosition: '0 40%'
        },
        '&.May'           : {
            backgroundImage   : "url('/assets/images/backgrounds/spring.jpg')",
            backgroundPosition: '0 40%'
        },
        '&.Jun'           : {
            backgroundImage   : "url('/assets/images/backgrounds/summer.jpg')",
            backgroundPosition: '0 80%'
        },
        '&.Jul'           : {
            backgroundImage   : "url('/assets/images/backgrounds/summer.jpg')",
            backgroundPosition: '0 80%'
        },
        '&.Aug'           : {
            backgroundImage   : "url('/assets/images/backgrounds/summer.jpg')",
            backgroundPosition: '0 80%'
        },
        '&.Sep'           : {
            backgroundImage   : "url('/assets/images/backgrounds/autumn.jpg')",
            backgroundPosition: '0 40%'
        },
        '&.Oct'           : {
            backgroundImage   : "url('/assets/images/backgrounds/autumn.jpg')",
            backgroundPosition: '0 40%'
        },
        '&.Nov'           : {
            backgroundImage   : "url('/assets/images/backgrounds/autumn.jpg')",
            backgroundPosition: '0 40%'
        },
        '&.Dec'           : {
            backgroundImage   : "url('/assets/images/backgrounds/winter.jpg')",
            backgroundPosition: '0 85%'
        }
    }
});

const viewNamesObj = {
    month    : {
        title: 'Month',
        icon : 'view_module'
    },
    week     : {
        title: 'Week',
        icon : 'view_week'
    },
    work_week: {
        title: 'Work week',
        icon : 'view_array'
    },
    day      : {
        title: 'Day',
        icon : 'view_day'
    },
    agenda   : {
        title: 'Agenda',
        icon : 'view_agenda'
    }
};

class CalendarHeader extends Toolbar {

    constructor(props) {
        super(props);
        
        this.state = {

            pendingCount: 0,
            InProgressCount: 0,
            completedCount: 0
        };
    }

    componentWillMount()
    {
        this.getTasks();
    }

    getTasks(){

        // axios.post('http://localhost:5003/job/tasks/byId', {'userId':this.props.user.employeeId})
        axios.post(window.crmServer+'/job/tasks/byId',{'userId':this.props.user.employeeId})
        .then(response => {

            console.log(response.data);
            var data = [];

            var pendingCount = 0;
            var InProgressCount = 0;
            var completedCount = 0;

            for(var i = 0; response.data.length>i; i++){

                if(response.data[i].SUBTASK_ASSIGN_STATUS === "Pending"){

                    pendingCount = pendingCount+1;
                }

                if(response.data[i].SUBTASK_ASSIGN_STATUS === "In Progress"){

                    InProgressCount = InProgressCount+1;
                }

                if(response.data[i].SUBTASK_ASSIGN_STATUS === "Completed"){

                    completedCount = completedCount+1;
                }

            }

            this.setState({ pendingCount:pendingCount });
            this.setState({ InProgressCount:InProgressCount });
            this.setState({ completedCount:completedCount });
        });

    }

    view = view => {
        this.props.onViewChange(view)
    };

    viewButtons()
    {
        let viewNames = this.props.views;
        const view = this.props.view;

        if ( viewNames.length > 1 )
        {
            return viewNames.map(name => (
                    <Tooltip title={viewNamesObj[name].title} key={name}>
                        <div>
                            <IconButton
                                aria-label={this.props.messages[name]}
                                onClick={this.view.bind(null, name)}
                                disabled={view === name}
                            >
                                <Icon>{viewNamesObj[name].icon}</Icon>
                            </IconButton>
                        </div>
                    </Tooltip>
                )
            )
        }
    }

    render()
    {
        const {classes, messages, label, date} = this.props;

        return (
            <MuiThemeProvider theme={FuseThemes['currentThemeDark']}>

                <div className={classNames(classes.root, moment(date).format('MMM'))}>

                    <div className="flex flex-1 flex-col p-12 justify-between z-10">

                        <div className="flex flex-col items-center sm:flex-row">
                            <div className="flex items-center my-16 sm:mb-0 md:w-1/3 z-10">
                                <Icon className="text-32 mx-12">today</Icon>
                                <Typography variant="title">Calendar</Typography>
                            </div>

                             <div className="flex items-center p-20 md:w-1/3 sm:mb-0">

                                    <Card className="m-8 w-1/3" >
                                                <Typography className="p-12 w-full" color="textSecondary">Pending</Typography>
                                                <Typography className="p-12 text-56 font-300 leading-none mt-8">
                                                    {this.state.pendingCount}
                                                </Typography>

                                        </Card>
                                    <Card className="m-8 w-1/3" >
                                                <Typography className="p-12 w-full" color="textSecondary">In Progress</Typography>
                                                <Typography className="p-12 text-56 font-300 leading-none mt-8">
                                                {this.state.InProgressCount}
                                                </Typography>

                                        </Card>
                                    <Card className="m-8 w-1/3" >
                                                <Typography className="p-12 px-4 w-full" color="textSecondary">Completed</Typography>
                                                <Typography className="p-12 text-56 font-300 leading-none mt-8">
                                                {this.state.completedCount}
                                                </Typography>

                                        </Card>
                            </div>

                            <div className="flex items-right md:w-1/3">
                                <Tooltip title="Today">
                                    <IconButton aria-label="today" onClick={this.navigate.bind(null, navigate.TODAY)}>
                                        <Icon>today</Icon>
                                    </IconButton>
                                </Tooltip>
                                {this.viewButtons()}
                            </div>
                        </div>

                        <div className="flex items-center justify-center">
                            <Tooltip title={messages.previous}>
                                <IconButton aria-label={messages.previous} onClick={this.navigate.bind(null, navigate.PREVIOUS)}>
                                    <Icon>chevron_left</Icon>
                                </IconButton>
                            </Tooltip>
                            <Typography variant="title">{label}</Typography>
                            <Tooltip title={messages.next}>
                                <IconButton aria-label={messages.next} onClick={this.navigate.bind(null, navigate.NEXT)}>
                                    <Icon>chevron_right</Icon>
                                </IconButton>
                            </Tooltip>
                        </div>
                    </div>
                </div>
            </MuiThemeProvider>
        )
    };
}

function mapStateToProps({ fuse, auth }) {
    return {
        user: auth.user
    }
}

export default withStyles(styles, {withTheme: true})(connect(mapStateToProps)(CalendarHeader));


// WEBPACK FOOTER //
// ./src/main/content/apps/calendar/CalendarHeader.js